import { defineComponent as _defineComponent } from 'vue'
import useI18n from '@/mixins/useI18n';
import { computed } from 'vue';
import { SHORT_MONTHS } from '@/models/DateTime';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXDatePickerYear',
  props: {
  selectedDate: {
    type: Date,
    required: true,
  },
  year: {
    type: Number,
    required: true,
  }
},
  emits: ['select-date'],
  setup(__props, { emit }) {

const props = __props;




const { locale } = useI18n();

const monthShortNames = computed(() => SHORT_MONTHS[locale.value]);



const selectedMonthIndex = computed(() => props.selectedDate.getMonth());
const selectedYear = computed(() => props.selectedDate.getFullYear());

const onSelectMonth = (month: number) => {
  const newDate = new Date(props.selectedDate);
  newDate.setMonth(month);
  newDate.setFullYear(props.year);
  emit('select-date', newDate);
};


return { __sfc: true,props, locale, monthShortNames, emit, selectedMonthIndex, selectedYear, onSelectMonth }
}

})